export default __webpack_public_path__ + "static/media/196.20bd49b1.png";